import {createAction} from 'redux-act';
import {ForecastViewParams} from '@/app/interfaces/weather';

export const setForecastViewParams = createAction<Partial<ForecastViewParams>>('forecast/setViewParams');
